//DAOSection4

// src/components/DAOSection4.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0% 5% 5% 5%; 
  background-color: #000000; /* 调整背景颜色根据需要 */
  width:60%;
  margin: 0 auto;
  flex-direction: row-reverse;

  @media (max-width: 500px) {
    flex-direction: column; /* 在小于500px时，垂直排列 */
    padding: 5% 0% 5% 0%;
    width:90vw;
  }
`;

const LeftColumn = styled.div`
  flex: 4;
  
  @media (max-width: 500px) {

    width:100%;
    text-align: center;
    
  }
  
`;

const Image = styled.img`
  width: 100%;
  height: auto;
`;



const RightColumn = styled.div`
  flex: 6; 
  width:60%;
  overflow: hidden;
  padding:0% 0% 0% 0%;
  text-align: left;

  @media (max-width: 500px) {
    
    width:100%;
    padding:0% ;

  }
  
`;

const GroupContainer = styled.div`
  
  

  padding:5% 5% 5% 0%;

  @media (max-width: 500px) {
    width:100%;
    margin:0 auto;
   
    padding:0% 0% 2% 0%;

  }
`;

const GroupTitle = styled.h3`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  margin-bottom: 5%;
  margin-top: 1%; 
  
  color: #FFFFFF;
  padding:0% 10% 0% 0%;


  p{

    font-size: 18px;
    line-height: 32px;
    color: #AFAFAF;
  }

  @media (max-width: 500px) {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    padding:5% 0% 0% 2% ;

    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
  }

`;

const Button = styled.a`
  text-decoration: none;
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;

  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  


  
  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top:0px;

    padding: 6px 20px;
    


  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;

const DAOSection4 = () => {
  return (
    <SectionContainer>
      <LeftColumn>
        <Image src="/images/DAOSec3_2.png" alt="Image Title" />
      </LeftColumn>
      <RightColumn>
        <GroupContainer>
          <GroupTitle>DAO 知識轉譯暨流程生產鏈規劃書 簡介<p>全球對 DAO 的關注已有大量討論，然而華語地區對此議題的資訊與討論仍相對少量。我們收集並整理翻譯三場重要分散式自治組織的討論資訊，供中文社群推廣 DAO 相關領域知識。</p></GroupTitle>
       
          <Button href="https://drive.google.com/file/d/1qFunnlVHxQhJto_5UduwJIGP2otIeeV8/view?usp=sharing" target="_blank" style={{ textDecoration: 'none' }}>閱讀更多</Button>

         
        </GroupContainer>
        
      </RightColumn>

    </SectionContainer>
    

  );
};

export default DAOSection4;
